import { Tooltip } from "@design-system/DataDisplay/Tooltip";
import { Switch } from "@design-system/Inputs/Switch";
import { type FC } from "react";
import { useSupplierQuestionnaireQuestionProofFilterTranslations } from "./i18n";

export const QuestionProofFilter: FC<{
    checked: boolean;
    onChange: (checked: boolean) => void;
}> = ({ checked, onChange }) => {
    const { t, keys } =
        useSupplierQuestionnaireQuestionProofFilterTranslations();

    return (
        <Tooltip>
            <Tooltip.Trigger asChild>
                <div>
                    <Switch
                        label={t(keys.title)}
                        checked={checked}
                        onChange={onChange}
                        type="helper"
                        labelPosition="right"
                    />
                </div>
            </Tooltip.Trigger>
            <Tooltip.Content>{t(keys.tooltip)}</Tooltip.Content>
        </Tooltip>
    );
};
